export const getMinimumStaggerDuration = (
  total: number,
  maxDuration: number = 0.5,
  minStagger: number = 0.1,
): number => Math.min(minStagger, maxDuration / total);
